
<form #addCityForm="ngForm">
    <div class="modal-header">
        <h4>Add City</h4>    
    </div>
    <div class="modal-body">
        <div class="form-group mt-4">
            <strong>Country</strong>
            <div class="mt-2">
              <ngx-select [items]="CountryData" optionValueField="countryId" optionTextField="countryName" 
                placeholder="Select" class="ngxdropdown"
              (select)="CountrySelected" [(ngModel)]="CountrySelected" [noAutoComplete]="false"        
              (ngModelChange)="OnchangeCountry($event)"
              [ngModelOptions]="{standalone: true}" required>
              </ngx-select>  
          </div>
        </div>
    <!-- <div class="form-group mt-4">
        <strong>City</strong>
        <div class="mt-2">
        <ngx-select [items]="cityData" optionValueField="cityId" optionTextField="cityName" 
          placeholder="Select" class="ngxdropdown"
        (select)="CitySelected" [(ngModel)]="CitySelected" [noAutoComplete]="false"        
        [ngModelOptions]="{standalone: true}" required>
        </ngx-select> 
    </div>
    </div> -->

    <div class="from-group mt-4">
      <strong>City</strong>
      <input type="text" autocomplete="off" class="form-control mt-2"  name="city" #city="ngModel" id="city" placeholder="Enter city name" ngModel required>
      <div *ngIf="city.invalid && (city.dirty || city.touched)" class="alert alert-danger">
        <div class="mt-2" *ngIf="city.errors.required" >     
          City is required.
        </div>
      </div>
    </div>

    
  <div class="form-group mt-4">
    <strong>Status</strong>
    <span class="icon-radiobutton_active mr-2" *ngIf="selectActiveStatus.isChecked"
      (click)="selectActiveStatus.isChecked = true"></span>
    <span class="icon-radiobutton_inactive mr-2" *ngIf="!selectActiveStatus.isChecked"
      (click)="selectInActiveStatus.isChecked = false ; selectActiveStatus.isChecked = true"></span>
    <span class="mr-3">Active</span>
    <span class="icon-radiobutton_active mr-2" *ngIf="selectInActiveStatus.isChecked"
      (click)="selectInActiveStatus.isChecked = true"></span>
    <span class="icon-radiobutton_inactive mr-2" *ngIf="!selectInActiveStatus.isChecked"
      (click)="selectInActiveStatus.isChecked = true ; selectActiveStatus.isChecked = false"></span>
    <span>Inactive</span>
  </div>
   
    </div>

    <div class="modal-footer">
        <button (click)="modalRef.hide()"
        type="button" class="button">
        Cancel
      </button> 
      <button (click)="AddNewCity(city.value)" 
      
      [disabled]="city.invalid || !(CountrySelected)"
      class="button blue" type="button">
        Add
      </button>
    </div>
</form>


